module.exports = __webpack_public_path__ + "img/parter-avatar11.4b11d0ad.png";